<div class="card" id="{{vaAgent._id.$oid}}" [ngClass]="getCSSClasses(vaAgent)">
    <div class="top-wrap" *ngIf="!packageLibrary">
        <!--ownership -->
        <ul>
            <!-- <li>
                <a href="javascript:Void(0)" ngbTooltip="Edit cards">
                    <span class="edit-card">
                        <i class="icon-edit"></i>
                    </span>
                </a>
            </li>
            <li>
                <a href="javascript:Void(0)" ngbTooltip="View card">
                    <span class="view-card">
                        <i class="icon-eye"></i>
                    </span>
                </a>
            </li> -->
            <!-- <li>
                <a ngbTooltip="This CoPilot is running">
                    <span *ngIf="vaAgent?.container_details?.status == 1" class="owner"><i class="icon-online"></i></span>
                </a>
            </li> -->
            <li>
                <a (click)="pinUser(vaAgent)">
                    <span class="iconB-pin"></span>
                </a>
            </li>
            <li>
                <a *ngIf="vaAgent.owner == 'true'" ngbTooltip="You own this project">
                    <span class="owner"><i class="icon icon-owner-new"></i></span>
                </a>
            </li>
            <li>
                <a *ngIf="vaAgent.owner == 'false' && vaAgent.project_role == 'viewer'" ngbTooltip="You have viewer access to  this project">
                    <span class="owner"><i class="icon icon-eye-new"></i></span>
                </a>
            </li>
            <li>
                <a *ngIf="vaAgent.owner == 'false' && vaAgent.project_role == 'editor'" ngbTooltip="You have editor access to  this project">
                    <span class="owner"><i class="icon icon-editor-new"></i></span>
                </a>
            </li>


            <li>
                <a *ngIf="vaAgent.owner == 'false' && vaAgent.project_role == 'instructor'" ngbTooltip="You have instructor level access to  this project">
                    <span class="instructor"></span>
                </a>
            </li>

            <li>
                <a *ngIf="vaAgent.shared == 'true'" (click)="openSharingModal(shareProjectModal)" class="shared-icon" ngbTooltip="{{ vaAgent.owner == 'true' ? 'This project is shared' : 'The project is shared with you'}}">
                    <i class="icon icon-shared-users-new"></i>
                </a>
            </li>
        </ul>
        <!--more dropdown -->

        <div ngbDropdown class="d-inline-block">
            <button class="btn restore" *ngIf="vaAgent.archive" (click)="restoreAgentFromTrash(vaAgent)"><i class="icon-cw"></i></button>
            <button class="btn delete" *ngIf="vaAgent.archive" (click)="hardDeleteProject(vaAgent)"><i class="icon icon-delete-garbage-streamline"></i></button>

            <button class="btn btn-more" id="dropdownBasic1" *ngIf="!vaAgent.archive" ngbDropdownToggle><i class="icon-more-horizontal"></i></button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <button class="dropdown-item" (click)="openEditModal(editProjectModal,vaAgent)">Edit
                    <!--<i class="icon icon-edit"></i>--> </button>
                <button class="dropdown-item" (click)="openSharingModal(shareProjectModal)"> Users
                    <!--<i class="icon icon-share-outline"></i>--> </button>
                <button *ngIf="vaAgent.project_type != 'universal'" class="dropdown-item sup" [disabled]="buttonStatus" (click)="cloneProject(vaAgent)"> Clone
                    <!--<i class="icon icon-delete-garbage-streamline"></i>--> </button>
                <button *ngIf="vaAgent.project_type != 'universal'" class="dropdown-item  sup" [disabled]="buttonStatus" (click)="downloadProject(vaAgent)">Download
                    <!--<i class="icon icon-delete-garbage-streamline"></i>--> </button>
                <button class="dropdown-item va_agent" [disabled]="buttonStatus" (mouseenter)="mouseHover($event)" (click)="deleteProject(vaAgent)">Delete
                    <!--<i class="icon icon-delete-garbage-streamline"></i>--> </button>

            </div>
        </div>

    </div>
    <div class="top-wrap" *ngIf="packageLibrary">
        <ul>
            <li>
                <a><span class="owner"><i class="icon icon-owner-new"></i></span></a>
            </li>
            <li class="name_lang">
                <p ngbTooltip="{{vaAgent.created_by}}">{{getTrimedText(vaAgent.created_by, 50)}}</p>
            </li>
        </ul>
    </div>
    <div class="card-content" (click)="setActiveVa(vaAgent)">
        <div class="card-top">
            <picture div class="thumb">
                <img src="{{vaAgent.va_avatar}}" class="img-fluid" alt="dummy">
            </picture>
            <a ngbTooltip="This Copilot is running" *ngIf="vaAgent?.container_details?.status == 1">
                <span class="owner"><i class="icon-online"></i></span>
            </a>
            <a ngbTooltip="This Copilot is down" *ngIf="vaAgent?.container_details?.status == 3">
                <span class="owner"><i class="icon-da-down"></i></span>
            </a>
        </div>
        <div class="title-text">
            <h4 ngbTooltip="{{vaAgent.title}}">{{getTrimedText(vaAgent.title, 20)}}</h4>
        </div>
        <div class="description title">
            <p *ngIf="!isSmallCard" placement="top" [ngbTooltip]="cardTooltip" [innerHTML]="vaAgent.description | safeHtml "></p>
        </div>
        <ng-template #cardTooltip>
            <p [innerHTML]="vaAgent.description"></p>
        </ng-template>
        <div class="card-bottom">
            <div *ngIf="vaAgent.project_type == 'library_project'" class="name_lang">
                <p ngbTooltip="{{vaAgent.client_name}}">{{getTrimedText(vaAgent.client_name, 50)}}</p>
                <div class="d-flex align-items-center" class="package-lib-tooltip">
                    <span *ngIf="packageLibrary"><i class="icon-lockedfill" ngbTooltip="No access"></i></span>
                    <span class="package-lib" *ngIf="vaAgent.project_type == 'library_project'">
                        <i class="iconB-package-library" [ngbTooltip]="vaAgent.pushed_to_library ? 'Package' : 'Not in package library'">
                            <span class="warning" *ngIf="!vaAgent.pushed_to_library"><i class="icon-topic-warnning" style="color: #ffc000;"></i>
                            </span>
                        </i>
                    </span>
                </div>
            </div>
            <div *ngIf="vaAgent.project_type != 'universal' && vaAgent.project_type != 'library_project'" class="name_lang">
                <p ngbTooltip="{{vaAgent.client_name}}">{{getTrimedText(vaAgent.client_name, 50)}}</p>
                <label class="btn btn-red" *ngIf="!isSmallCard && vaAgent.language">{{vaAgent.language}}</label>
            </div>
            <div *ngIf="vaAgent.project_type == 'universal'" class="name_lang">
                <p ngbTooltip="{{vaAgent.client_name}}">{{getTrimedText(vaAgent.client_name, 50)}}</p>
                <label class="btn universal-bot"><i class="iconB-connect"></i></label>
            </div>
            <div class="days_left" *ngIf="vaAgent.archive">
                <span>{{vaAgent.days_left}} days left for restoration.</span>
            </div>
        </div>
    </div>
</div>


<ng-template #editProjectModal let-c="close" let-d="dismiss">
    <div class="modal-body add-popup">
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click') ; regenrate()">
            <span aria-hidden="true"> <i class="icon icon-cira"></i></span>
        </button>
        <h4 class="modal-title">Edit Copilot Details</h4>
        <!-- <p>Edit CoPilot details in below fields</p> -->
        <div class="form-wrap">
            <form [formGroup]="projectEditForm">
                <div class="input-wrap">
                    <div class="agent-name form-group">
                        <input type="text" formControlName="title" class="c-form-control" #title value="{{agentTitle}}" (keyup)="titleUpdate($event,title.value.length )" full-width required autofocus placeholder="Enter Copilot Title">
                        <!-- <form-validation-message [control]="projectEditForm.controls.title"></form-validation-message> -->
                        <div *ngIf="title.value.length > 32 " class="error-msg"> Title should be less than 32 characters
                        </div>
                    </div>
                    <div class="descrp form-group ">
                        <textarea #decrsp value="{{agentDescrp}}" formControlName="decrsp" class="c-form-control" (keyup)="descrpUpdate($event, decrsp.value.length)" placeholder="Description"></textarea>
                        <!-- <form-validation-message [control]="projectEditForm.controls.decrsp"></form-validation-message> -->
                        <div *ngIf="decrsp.value.length > 120 " class="error-msg">Description should be less than 120 characters
                        </div>
                        <div class="error-msg mt-1" *ngIf="!formValid()">{{errMessage}}</div>
                    </div>
                    <div>
                        <button type="submit" (click)="saveTitle( title.value,decrsp.value);" [disabled]="!formValid()" class="btn btn-green">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</ng-template>


<ng-template #shareProjectModal let-c="close" let-d="dismiss">
    <div class="modal-body add-popup">
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click') ; regenrate()">
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">Project User</h4>
        <div class="form-wrap">
            <div class="input-wrap">

                <div class="shared-list">
                    <h5>Who has access</h5>
                    <ng-scrollbar [trackX]=false class="d-scroll">
                        <div class="loading-tree" *ngIf="tree_loader_status == true;">
                            <img src="/assets/images/tree-loader.gif" alt="">
                            <h5>Loading users...</h5>
                            <div class="loading-tree-overlay">
                            </div>
                        </div>
                        <ul *ngIf="tree_loader_status == false;">
                            <ng-template ngFor let-user [ngForOf]="sharedUserList" let-i="index">
                                <li *ngIf="user.is_owner =='true'">
                                    <span class="thumb"></span>
                                    <span class="text">{{user.name}} <sup class="deactivated" *ngIf="user.status_info[0].status_id==3">(Deactivated)</sup>
                                        <small>{{user.email}}</small>
                                    </span>
                                    <span class="info">Is owner</span>
                                </li>
                            </ng-template>
                            <ng-template ngFor let-user [ngForOf]="sharedUserList" let-i="index">

                                <li *ngIf="user.is_owner=='false'" class="access-dropdown">

                                    <span class="thumb"></span>
                                    <span class="text">{{user.name}} <sup class="deactivated" *ngIf="user.status_info[0].status_id==3">(Deactivated)</sup>
                                        <small>{{user.email}}</small>
                                    </span>
                                    <div class="info btn-group ml-auto">
                                        <div class="dropdown">
                                            <div class="form-group" [ngClass]="{disabled: !showSharePannel()}">
                                                <i class="icon-angle-down c-dropdown-icon"></i>
                                                <select [disabled]="!showSharePannel() || user.status_info[0].status_id==3" #userRole class="c-dropdown small-dropdown" (change)="changeUserRole(userRole.value,user)">
                                                    <option value="{{user.role}}">{{user.role}}</option>
                                                    <ng-template ngFor let-role [ngForOf]="userRoles">
                                                        <option *ngIf="role != user.role && vaAgent.project_type != 'universal' " value="{{role}}">{{role}}</option>
                                                    </ng-template>
                                                </select>
                                            </div>
                                        </div>
                                        <button class="btn btn-red sml-red-btn" (click)=removeUser(user.email)>
                                            <i class="icon-delete-garbage-streamline"></i>
                                        </button>
                                    </div>
                                </li>
                            </ng-template>
                        </ul>
                    </ng-scrollbar>
                </div>

                <div *ngIf="showSharePannel()">
                    <label for="">Share projects</label>
                    <form [formGroup]="projectShareForm">
                        <div class="row">
                            <div class="col-sm-9">
                                <div class="form-group">
                                    <input #email type="email" formControlName="email" class="c-form-control" id="projectInput" placeholder="Enter Email Address" autocomplete="off" [(ngModel)]="SelectedUser" (keyup)="listHidden=false">
                                    <form-validation-message [control]="projectShareForm.controls.email"></form-validation-message>
                                </div>
                                <!-- <div class="search-dropdown" *ngIf="SelectedUser != '' && userList.length > 0" [hidden]="listHidden">
                                    <ng-scrollbar class="dropdown-scroll">
                                        <ul class="search-dropdown-list">
                                            <li *ngFor="let node of userList | searchBy: 'email' : SelectedUser" (click)="SelectedUser=node.email;listHidden=true">
                                                <span>{{node.email}}</span>
                                            </li>
                                        </ul>
                                    </ng-scrollbar>
                                </div> -->
                            </div>
                            <div class="col-sm-3">
                                <div class="form-group d-flex">
                                    <i class="icon-angle-down c-dropdown-icon"></i>
                                    <select class="c-dropdown c-icon-control" formControlName="role" [(ngModel)]="SelectedRole">
                                        <option [ngValue]="undefined" disabled selected>Role</option>
                                        <option *ngIf="vaAgent.project_type == 'universal'" [ngValue]="'admin'">admin</option>
                                        <ng-container *ngIf="vaAgent.project_type != 'universal'">
                                            <option *ngFor="let role of userRoles" [ngValue]="role">{{role}}</option>
                                        </ng-container>
                                    </select>
                                    <form-validation-message [control]="projectShareForm.controls.role"></form-validation-message>
                                </div>
                            </div>
                        </div>

                        <button type="submit" class="btn btn-green" [disabled]="!projectShareForm.valid" (click)="shareProject(email.value,SelectedRole)">Share</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</ng-template>